import { ShareArrow } from '@/public/assets/v2/images/icons'
import { cssClass } from '@/shared/utils'
import { highlightHeaderText } from 'containers/highlights/styles/highlight.css'
import { HighlightThumbnail } from './HighlightThumbnail'
import { HighlightCardContent } from './HighlighCardContent'
import { TextSkeleton } from '@/components/skeleton/TextSkeleton'

export const HighlightCardLoadig = () => {
  return (
    <div className="full-w bg-white-primary rounded-12">
      <div className="flex items-start justify-space-between p-12">
        <div
          className={cssClass(['flex flex-column gap-16', highlightHeaderText])}
        >
          <TextSkeleton width={230} height={20} />
          <TextSkeleton width={50} height={16} />
        </div>
        <div>
          <ShareArrow className="cursor-pointer text-22" />
        </div>
      </div>
      <HighlightThumbnail loading />
      <HighlightCardContent loading />
    </div>
  )
}
